$(document).ready(function() {
  var headerHeight = $('#header').outerHeight();
  $('.aw-styling-nav a[href^="#"]').on('click', function(event) {
    event.preventDefault();
    var target = $(this.getAttribute('href'));
    if (target.length) {
      $('html, body').stop().animate({
        scrollTop: target.offset().top - headerHeight -30
      }, 1000);
    }
  });
});
